import reviewRoute from './review'

const routes = [reviewRoute]

export default routes
